export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7554.41d9d5ef.jpg";